import { Box, Button, Dialog, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import PdfPreview from "../../../components/PdfPreview";
import useInputObject from "../../../hooks/useInputObject";

const PrintPreview = (props) => {
  const { printPreview } = props;
  useEffect(() => {
  }, [printPreview.Value.url]);
  return (
    <Dialog fullScreen open={printPreview.Value.open}>
      <Box padding={2}>
        <Grid container alignItems="center">
          <Grid item xs>
            <Typography>帳票PDFプレビュー</Typography>
          </Grid>
        </Grid>

        <Box height="calc(100vh - 130px)" marginY={1}>
          <PdfPreview pdfUrl={printPreview.Value.url} />
        </Box>

        <Box MarginTop={1}>
          <Grid container spacing={1}>
            <Grid item xs />
            <Grid item xs="auto">
              <Button
                variant="outlined"
                onClick={() => printPreview.update("open", false)}
              >
                戻る
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Dialog>
  );
};

export default PrintPreview;
